import React from 'react';
import { ColumnDef, createColumnHelper } from '@tanstack/react-table';
import { GetAutofulfillAddressesResponse } from '../../../../server/routers/autofulfill/procedures/getAutofulfillAddresses';
import { Text, Button } from '@datavant/uikit';
import { VStack, HStack, Box } from '@chakra-ui/react';
export type AddressConfirmationTableRow = GetAutofulfillAddressesResponse[number] & {
    excluded: boolean;
    excludeRow: (addressId: string) => void;
};

export const actionColumnId = 'action';

const columnHelper = createColumnHelper<AddressConfirmationTableRow>();

export const columnDefs: ColumnDef<AddressConfirmationTableRow, any>[] = [
    columnHelper.accessor(row => row.facilityName, {
        id: 'address',
        header: 'Address',
        cell: ({
            row: {
                original: {
                    excluded,
                    address: { line1, line2, cityStateZip },
                },
            },
        }) => {
            return excluded ? (
                <VStack gap={0} alignItems={'flex-start'} p={'8px'}>
                    <Text.Status as="s" size={'xs'} appearance={'disabled'}>
                        {line1}
                    </Text.Status>
                    {line2 && (
                        <Text.Status as="s" size={'xs'} appearance={'disabled'}>
                            {line2}
                        </Text.Status>
                    )}
                    <Text.Status as="s" size={'xxs'} appearance={'disabled'}>
                        {cityStateZip}
                    </Text.Status>
                </VStack>
            ) : (
                <VStack gap={0} alignItems={'flex-start'} p={'8px'}>
                    <Text.Contrast size={'xs'} appearance={'medium'}>
                        {line1}
                    </Text.Contrast>
                    {line2 && (
                        <Text.Contrast size={'xs'} appearance={'medium'}>
                            {line2}
                        </Text.Contrast>
                    )}
                    <Text.Contrast size={'xxs'} appearance={'minimum'}>
                        {cityStateZip}
                    </Text.Contrast>
                </VStack>
            );
        },
        meta: {
            column: {
                isSortable: true,
            },
        },
    }),
    columnHelper.accessor(row => row.facilityName, {
        id: 'facilityName',
        header: 'Facility Name',
        cell: ({
            row: {
                original: { facilityName, excluded },
            },
        }) => {
            return excluded ? (
                <Text.Status as="s" size={'xs'} appearance={'disabled'}>
                    {facilityName ?? '--'}
                </Text.Status>
            ) : (
                <Text.Contrast size={'xs'} appearance={'medium'}>
                    {facilityName ?? '--'}
                </Text.Contrast>
            );
        },
        meta: {
            column: {
                isSortable: true,
            },
        },
    }),
    columnHelper.display({
        id: actionColumnId,
        header: 'Action',
        cell: ({
            row: {
                original: { excluded, excludeRow, id },
            },
        }) => (
            <Box py={'8px'}>
                {excluded ? (
                    <Text.Status appearance={'negative'} size={'xxs'} weight={'semibold'}>
                        Excluded
                    </Text.Status>
                ) : (
                    <Button
                        intent={'negative'}
                        buttonAppearance={'outline'}
                        size={'sm'}
                        onClick={() => excludeRow(id)}
                    >
                        Exclude this Site
                    </Button>
                )}
            </Box>
        ),
        meta: {
            column: {
                isRightAligned: true,
            },
        },
    }),
];
